
















































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import { fetchControl } from './fetchControl';
import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Console } from 'console';
import VerDetalle from './VerDetalle/VerDetalle.vue';

import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { Angular } from '@sentry/integrations';

@Component({
  components: {
    MantenedorGrid,
    DatePicker,
    Confirmation,
    FormFieldsContainer,
    VerDetalle,
  },
})
export default class ControlBajaCliente extends ComponenteBase {
  dialogConfirmacionClose: boolean = false;
  filtro: string = '';
  ordesList: any[] = [];
  showModalDetalle: boolean = false;
  menu: boolean = false;

  funcionalidad: Funcionalidades = Funcionalidades.ControlBajaCliente;

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      value: '',
      id: '',
    },
    cliente: {
      label: 'Cliente',
      value: '',
      id: '',
    },
    motivo: {
      label: 'Motivo Tipo',
      value: '',
      id: '',
    },
    tramo: {
      label: 'Tramo',
      value: '',
      id: '',
    },
    dateStart: {
      label: 'Fecha Solicitud Desde',
      value: moment()
        .subtract(1, 'month')
        .startOf('day'),
      id: '',
    },
    dateEnd: {
      label: 'Fecha Solicitud Hasta',
      value: moment().endOf('day'),
      id: '',
    },
  };

  clearFilters() {
    this.formFields.dateStart.value = moment()
      .subtract(1, 'months')
      .startOf('day');
    this.formFields.dateEnd.value = moment().endOf('day');
    this.formFields.estado.value = '';
    this.formFields.motivo.value = '';
    this.formFields.cliente.value = '';
    this.formFields.tramo.value = '';
  }

  async getSolicitudes() {
    let self = this;
    this.loadingService.showLoading();
    return fetchControl(
      {
        fechaInicio: moment(this.formFields.dateStart.value.toString())
          .startOf('day')
          .format('YYYY-MM-DD HH:mm'),
        fechafin: moment(this.formFields.dateEnd.value.toString())
          .endOf('day')
          .format('YYYY-MM-DD HH:mm'),
        estado: this.formFields.estado.value
          ? this.formFields.estado.value
          : '',
        motivo: this.formFields.motivo.value
          ? this.formFields.motivo.value
          : '',
        cliente: this.formFields.cliente.value
          ? this.formFields.cliente.value
          : '',
        tramo: this.formFields.tramo.value
          ? moment(this.formFields.tramo.value.toString()).format('YYYY-MM-01')
          : '',
      },
      'conecta_consulta_control_baja_cliente/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          console.log(data.data.data.LISTA[0]);
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  estados: any = ['Anulado', 'Ejecutado', 'Solicitado'];
  motivos: any = [];
  clientes: any = [];
  async getFilter() {
    let self = this;
    this.loadingService.showLoading();
    return fetchControl(
      { '': '' },
      'conecta_solicitud_baja_cliente/get_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.motivos = data.data.MOTIVOS;
          this.clientes = data.data.CLIENTES;
          this.loadingService.hideLoading();
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ocurrió un error al cargar la información de los filtros',
          { timeout: 3000 }
        );
        this.loadingService.hideLoading();
      });
  }

  async filtrar() {
    if (this.formFields.dateStart.value > this.formFields.dateEnd.value) {
      this.$snotify.error(
        'La fecha de inicio no puede ser superior a la fecha fin',
        {
          timeout: 3000,
        }
      );
      return;
    }
    this.ordesList = await this.getSolicitudes();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getSolicitudes();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  texto_reporte: string = '';
  showReporteGenerado: boolean = false;

  closeReporte() {
    this.showReporteGenerado = false;
  }

  async exportarExcel() {
    let self = this;
    this.loadingService.showLoading();
    return fetchControl(
      {
        user_id: JSON.parse(window.localStorage.user).id,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        fechaInicio: moment(this.formFields.dateStart.value.toString())
          .startOf('day')
          .format('YYYY-MM-DD HH:mm'),
        fechafin: moment(this.formFields.dateEnd.value.toString())
          .endOf('day')
          .format('YYYY-MM-DD HH:mm'),
        tramo: this.formFields.tramo.value
          ? moment(this.formFields.tramo.value.toString()).format('YYYY-MM-01')
          : '',
        motivo: this.formFields.motivo.value
          ? this.formFields.motivo.value
          : '',
        estado: this.formFields.estado.value
          ? this.formFields.estado.value
          : '',
        cliente: this.formFields.cliente.value
          ? this.formFields.cliente.value
          : '',
      },
      'conecta_consulta_control_baja_cliente/exportar_excel'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al exportar excel', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
  ];

  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  loadingService = new LoadingService();
  handleErrors: HandleErrors = new HandleErrors();
  AccionesPerfilesAsociados: number = 0;

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  dateFormatter(params: any) {
    return params && params.movifecha_recibe != ''
      ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
      : '';
  }

  dateFormatterTramo(params: any) {
    return params && params.tramo != ''
      ? moment(params.value).format('YYYY-MM')
      : '';
  }

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Número Baja',
        field: 'bajaclinumero',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 150,
        width: 150,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Solicitud',
        field: 'bajaclifecha_alta',
        resizable: true,
        sortable: true,
        width: 220,
        minWidth: 220,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Usuario',
        field: 'full_name',
        sortable: true,
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Tramo',
        field: 'bajaclitramo',
        width: 100,
        minWidth: 100,
        lockPinned: true,
        sortable: true,
        resizable: true,
        valueFormatter: this.dateFormatterTramo,
      },
      {
        headerName: 'Motivo',
        field: 'motiname',
        width: 300,
        minWidth: 300,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Cliente',
        field: 'cliente',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        resizable: true,
        width: 150,
        minWidth: 150,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Autor',
        field: 'bajaclidetautor',
        resizable: true,
        width: 150,
        minWidth: 150,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Concepto',
        field: 'bajaclidetconcepto',
        resizable: true,
        width: 150,
        minWidth: 150,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Equipos Esperados',
        field: 'bajaclidetcant_equipos',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Periféricos Esperados',
        field: 'bajaclidetcant_perifericos',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Fecha CRM',
        field: 'bajaclidetcrm_fecha',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Fecha Verifica',
        field: 'bajaclifecha_ejecuta',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Nro Tramite Sim',
        field: 'sbajasimnumero',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Dispositivos Detectados',
        field: 'equipos_confirmados',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Sim Detectadas',
        field: 'sims_confirmadas',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Estado Tramite Sim',
        field: 'estado_sim',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      makeAccionesColumnDef(this.funcionalidad),
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 30,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  async revertirSolicitud() {
    let self = this;
    this.loadingService.showLoading();
    return fetchControl(
      {
        solicitud: this.editedItem,
        usuario: JSON.parse(window.localStorage.user).id,
      },
      'conecta_verificacion_baja_cliente/revertir_ejecucion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.filtrar();
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.filtrar();
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al revertir la ejecución', {
          timeout: 3000,
        });
        this.filtrar();
      })
      .finally(() => {
        this.loadingService.hideLoading();
        this.filtrar();
        return null;
      });
  }

  async revertir() {
    await this.revertirSolicitud();
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('YYYY-MM-DD');
  }
  editedItem: any;
  editedItemCliente: any;
  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.ControlBajaCliente) {
        if (data.action === Accion.VerDetalle) {
          this.editedItem = null;
          // Editar - Ver Detalle

          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.editedItem = data.cellRendererParams.data.bajaclinumero;
            this.editedItemCliente = data.cellRendererParams.data.cliid;
            this.showModalDetalle = true;
          }
        }
      }
    });
  }

  mounted() {
    this.initialize();
    this.getFilter();
  }

  moduloModalCallback(val: boolean) {
    this.showModalDetalle = val;
    this.filtrar();
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
  }
}
